import { ChangeDetectionStrategy, Component, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectButton } from 'primeng/selectbutton';

export type ShareDialogGranteeType = 'USER' | 'GROUP';

@Component({
  selector: 'bd-share-dialog-type',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <p-selectbutton
      [options]="typeOptions"
      optionLabel="label"
      optionValue="value"
      [ngModel]="type()"
      (ngModelChange)="type.set($event)"
      [allowEmpty]="false"
      class="self-start"
    />
  `,
  imports: [SelectButton, FormsModule],
})
export class BdShareDialogTypeComponent {
  public readonly type = model<ShareDialogGranteeType>('USER');

  protected readonly typeOptions: {
    label: string;
    value: ShareDialogGranteeType;
  }[] = [
    { label: 'Benutzer', value: 'USER' },
    { label: 'Gruppe', value: 'GROUP' },
  ];
}
